import React from "react";
import { Tooltip, Typography } from "antd";
import { shorterString } from "../utils/string";

const { Text } = Typography;

const ShorterTextWithTooltip = ({ text, maxLength, strong = false, style = {} }) => (
  <>
    {text.length > maxLength && (
      <Tooltip title={<Text>{text}</Text>} color={"white"}>
        <Text style={style} strong={strong}>
          {shorterString(text, maxLength)}
        </Text>
      </Tooltip>
    )}
    {text.length <= maxLength && (
      <Text style={style} strong={strong}>
        {text}
      </Text>
    )}
  </>
);

export { ShorterTextWithTooltip };
